export const composeChatRedirectParams = (userUid, initialChatMsg, payload) => {
  return {
    chatWithThisUser: userUid,
    initialChatMsg: initialChatMsg,
    regardingPropery: payload
  }
}






// WEBPACK FOOTER //
// ./src/chatRepository.js